import { useMemo } from "react";

import type { MeView } from "../api/types";
import { MoreMenu } from "./frame/MoreMenu";
import { ViewTabs } from "./frame/ViewTabs";
import { navigationFor } from "./navigation";

export interface TopNavProps {
  me: MeView;
  /** A number to show after a tab's name, by the tab's id (the live count of the Review tab). */
  badges?: Readonly<Record<string, number>>;
}

/**
 * The navigation of the bar: the view tabs, then the More menu with every older screen. A person sees only what their role
 * opens. The pieces are in `frame/`; this puts them in one landmark, so the keyboard and a screen reader find them together.
 */
export function TopNav({ me, badges }: TopNavProps) {
  const { tabs, more } = useMemo(() => navigationFor(me), [me]);
  return (
    <nav aria-label="Main" className="frame__nav">
      <ViewTabs tabs={tabs} badges={badges} />
      <MoreMenu groups={more} />
    </nav>
  );
}
